export const pictureSwiperTypes = {
    TOGGLE_VISIBILITY: 'PICTURE_SWIPER_TOGGLE_VISIBILITY',
};
